<template>
  <div v-if="url">
    <h3>Whistleblower setup</h3>
    <p class="mt-1">
      URL last edited {{ url.createdAction.timestamp | formatDate }} by
      {{ url.createdAction.userDisplayName }}
    </p>

    <vx-card class="mt-6">
      <!-- Vuesax textfield -->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Whistleblower URL</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            class="w-full"
            v-model="url.url"
            placeholder="Whistleblower url"
          />
        </div>
      </div>

      <vs-button @click="saveUrl" color="primary">Save</vs-button>
    </vx-card>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      url: null,
    };
  },
  computed: {},
  methods: {
    async getUrl() {
      this.$vs.loading();

      this.$http
        .get(process.env.VUE_APP_API + "/Whistleblower")
        .then((resp) => {
          console.log("Got url", resp.data);
          this.url = resp.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    async saveUrl() {
      this.$vs.loading();

      this.$http
        .post(process.env.VUE_APP_API + "/Whistleblower/SubmitUrl", { url: this.url.url })
        .then(async () => {
          await this.getUrl();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  async mounted() {
    await this.getUrl();
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

div.search input {
  height: 46px;
  border-radius: 23px;
  border-color: #dae1e7;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
